import React, { useState } from "react";
import { Button } from "reactstrap";
import { JobWarning, WarningType } from "../../../../../common/api/v1.1/types/jobs";

import { StateCallbacks } from "../state";
import { State } from "../types";

import "./styles.scss";

type Props = Readonly<{
  review: boolean;
  state: State;
  warning: JobWarning;
  resolveWarning: (warning: JobWarning) => Promise<void>;
  stateCallbacks: StateCallbacks;
  focusDataPoints: () => void;
}>;

export const Warning = ({ review, state, stateCallbacks, warning, resolveWarning, focusDataPoints}: Props) => {

  const [resolved, setResolved] = useState(false);
  

  let templates : any = {};
  templates[WarningType.BAD_SUPPORT] = "is supported by entire table.  Please change the support to a specific cell";
  templates[WarningType.STRANGE_VALUE] = "has a value that does not match taxonomy";
  templates[WarningType.INEXACT_VALUE] = "is expected to exactly match the text, but does not";
  templates[WarningType.UNREVIEWED_DOC] = "All data points in this document are machine predictions. This is possible as long as a human reviewed these predictions and submitted as is. This can also be a document that has not been reviewed in which case ML might learn to reproduce errors.";
  templates[WarningType.EMPTY_DOC] = "This document contains no data points at all!";

  return (
        <div className={"warning-card " + (resolved ? "resolved": "")}>
            <div className="warning-card-left">
                <div>
                    <span className="warning-card-dp"
                        onClick={() => {
                            focusDataPoints();
                            stateCallbacks.onSelectDataPoint(warning.dataPoint)
                        }}
                    >
                        {warning.dataPoint}
                    </span>   
                    <span>
                        {" " + templates[warning.type]}
                    </span>
                </div>
                <div className="warning-card-message">
                    {warning.message}
                </div>
            </div>

            <div>
                <Button 
                    disabled={resolved}
                    color="secondary" 
                    onClick={() => {
                    resolveWarning(warning).then(done => {
                        setResolved(true);
                    })
                }} type="button">
                    {resolved ? "Suppressed" : "Suppress"}
                </Button>
            </div>
        </div>
    )
};